// Module
var code = "<i class=\"{{ icon }}\"></i><ng-transclude></ng-transclude> ";
// Exports
module.exports = code;